module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/26255153f92ea41df149a58d3c3fe2cf.svg";